import type { DriverRankTierEarningSettingAdminDto } from '@/backend/market'
import { DriverRankTierEarningSettingEntity } from '../../domain/entities/DriverRankTierEarningSettingEntity'
import { DriverRankTierVehicleDistanceRateEntity } from '../../domain/entities/DriverRankTierVehicleDistanceRateEntity'

export class DriverRankTierEarningSettingModel extends DriverRankTierEarningSettingEntity {
  constructor(data: DriverRankTierEarningSettingAdminDto) {
    super()
    this.id = data.id
    this.tierConfigId = data.tierConfigId
    this.regionId = data.regionId
    this.tierName = data.tierName
    this.vehicleDistanceRates =
      data.vehicleDistanceRates?.map((item) => {
        const rate = new DriverRankTierVehicleDistanceRateEntity()
        rate.id = item.id
        rate.tierConfigId = item.tierConfigId
        rate.vehicleTemplateId = item.vehicleTemplateId
        rate.pickupFee = item.pickupFee
        rate.dropoffFee = item.dropoffFee
        rate.additionalFee = item.additionalFee
        rate.distanceFeePerKm = item.distanceFeePerKm
        return rate
      }) ?? []
  }
}
